(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-timer"] && !Shopify.designMode) return;
  try {
    class AnnouncementTimer extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-clock]');
      this.endTime = Date.parse(this.dataset.endTime);

      // An unparseable date means the merchant hasn't finished setting up:
      // keep the message and button, drop the meaningless digits.
      if (!this.clock || isNaN(this.endTime)) {
        if (this.clock) this.clock.hidden = true;
        return;
      }

      this.units = Array.from(this.querySelectorAll('[data-unit]')).map((element) => ({
        element: element,
        key: element.dataset.unit,
        digits: element.querySelector('[data-digits]'),
      }));

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      // Background tabs throttle timers, so resync as soon as we're visible again.
      this.onVisibilityChange = () => {
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    tick() {
      const remaining = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining / 3600) % 24,
        minutes: Math.floor(remaining / 60) % 60,
        seconds: remaining % 60,
      };

      this.units.forEach((unit) => {
        if (unit.key === 'days') unit.element.hidden = values.days === 0;
        this.renderUnit(unit, values[unit.key]);
      });

      if (remaining === 0) {
        this.stop();
        this.classList.add('announcement-timer--expired');
      }
    }

    renderUnit(unit, value) {
      let text = String(value);
      if (text.length < 2) text = '0' + text;

      // Day counts above 99 need a third card; going back under 100 drops it.
      while (unit.digits.children.length < text.length) {
        unit.digits.insertBefore(this.createDigit(), unit.digits.firstChild);
      }
      while (unit.digits.children.length > text.length) {
        unit.digits.removeChild(unit.digits.firstChild);
      }

      Array.from(unit.digits.children).forEach((digit, index) => {
        this.setDigit(digit, text.charAt(index));
      });
    }

    createDigit() {
      const digit = document.createElement('span');
      digit.className = 'announcement-timer__digit';
      digit.setAttribute('data-digit', '');

      const face = document.createElement('span');
      face.className = 'announcement-timer__digit-face';
      face.textContent = '0';
      digit.appendChild(face);

      return digit;
    }

    setDigit(digit, value) {
      // Clear any face whose exit animation never got to fire (hidden tab, or
      // the days group being toggled off mid-flip).
      digit.querySelectorAll('.announcement-timer__digit-face--out').forEach((face) => face.remove());

      const current = digit.querySelector('.announcement-timer__digit-face');
      if (current && current.textContent === value) return;

      if (!current || this.reducedMotion.matches) {
        if (current) {
          current.textContent = value;
        } else {
          const face = document.createElement('span');
          face.className = 'announcement-timer__digit-face';
          face.textContent = value;
          digit.appendChild(face);
        }
        return;
      }

      const next = document.createElement('span');
      next.className = 'announcement-timer__digit-face announcement-timer__digit-face--in';
      next.textContent = value;
      next.addEventListener(
        'animationend',
        () => next.classList.remove('announcement-timer__digit-face--in'),
        { once: true }
      );
      digit.appendChild(next);

      current.classList.add('announcement-timer__digit-face--out');
      current.addEventListener('animationend', () => current.remove(), { once: true });
      // `animationend` never fires while the tab is backgrounded, so don't let
      // the retired face outlive the flip.
      setTimeout(() => current.remove(), 800);
    }
  }

  if (!customElements.get('announcement-timer')) {
    customElements.define('announcement-timer', AnnouncementTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-buy-now]');
    if (!btn || btn.hasAttribute('aria-disabled') || btn.disabled) return;

    var form = btn.closest('form');
    if (!form) return;
    var idInput = form.querySelector('.product-variant-id');
    var submitBtn = form.querySelector('.product-form__submit');
    if (!idInput || !idInput.value || (submitBtn && submitBtn.disabled)) return;

    // Quantity input sits outside the form (form="..."), so read it via form.elements.
    var qtyInput = form.elements.namedItem('quantity');
    var qty = parseInt(qtyInput && qtyInput.value, 10);
    if (!(qty > 0)) qty = 1;

    // Carry the Dibs selling plan, otherwise a partial-payment pre-order bought
    // through Buy it now is charged in full instead of the deposit. :checked first
    // for a radio group, then the hidden input / select Dibs injects.
    // :not(:disabled): preorder-gate.liquid disables the input on in-stock variants and in
    // built-in (full payment only) mode, and a disabled input must not submit.
    var spEl =
      form.querySelector('[name="selling_plan"]:checked:not(:disabled)') ||
      form.querySelector('[name="selling_plan"]:not(:disabled)');
    var line = { id: Number(idInput.value), quantity: qty };
    if (spEl && spEl.value) line.selling_plan = Number(spEl.value);

    // Pre-order note (see the data-preorder-property input above). Keyed off the
    // button's data-preorder, the same source of truth the gate uses.
    var propEl = form.querySelector('[data-preorder-property]');
    if (propEl && submitBtn && submitBtn.hasAttribute('data-preorder')) {
      line.properties = {};
      line.properties[propEl.name.slice('properties['.length, -1)] = propEl.value;
    }

    var items = [line];
    var section = btn.closest('.shopify-section') || document;
    var setup = section.querySelector('setup-selector');
    // The pad is in stock and paid in full — padItems() lines carry no selling plan.
    if (setup && typeof setup.padItems === 'function') {
      items = items.concat(setup.padItems(qty));
    }

    var productForm = btn.closest('product-form');
    var errorWrap = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    var errorText = errorWrap && errorWrap.querySelector('.product-form__error-message');
    if (errorWrap) errorWrap.hidden = true;
    function showError(message) {
      if (!errorWrap || !errorText) return;
      errorText.textContent = message || window.cartStrings && window.cartStrings.error || '';
      errorWrap.hidden = !errorText.textContent;
    }

    var spinner = btn.querySelector('.loading__spinner');
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          showError(response.description || response.message);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        showError();
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });

  /* Shop Similar: scroll to Related Products section */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-shop-similar]');
    if (!btn) return;
    var el = document.querySelector('.related-products');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-pairs-with"] && !Shopify.designMode) return;
  try {
    // Delegated on document and guarded so drawer re-renders don't stack listeners.
  if (!window.__cartPairsBound) {
    window.__cartPairsBound = true;

    // Keep the hidden variant id + displayed price in sync with the size dropdown.
    document.addEventListener('change', function (event) {
      var select = event.target.closest('.cart-pairs-card__select');
      if (!select) return;
      var card = select.closest('.cart-pairs-card');
      if (!card) return;
      var idInput = card.querySelector('.product-variant-id');
      var priceEl = card.querySelector('[data-price]');
      var option = select.options[select.selectedIndex];
      if (idInput) idInput.value = select.value;
      if (priceEl && option && option.dataset.price) priceEl.textContent = option.dataset.price;
      // The struck original follows the size too (empty when that size isn't on sale).
      var compareEl = card.querySelector('[data-compare]');
      var compareWrap = card.querySelector('[data-compare-wrap]');
      if (compareEl && option) {
        var compare = option.dataset.compare || '';
        compareEl.textContent = compare;
        if (compareWrap) compareWrap.hidden = !compare;
        var priceWrap = card.querySelector('.cart-pairs-card__price');
        if (priceWrap) priceWrap.classList.toggle('cart-pairs-card__price--sale', !!compare);
      }
    });

    // Custom carousel arrows sitting next to the "Pairs perfectly with" title.
    function cartPairsList(el) {
      var wrap = el.closest('.cart-pairs');
      return wrap ? wrap.querySelector('.slider') : null;
    }
    function cartPairsStep(list) {
      var items = list.querySelectorAll('[id^="Slide-"]');
      if (items.length > 1) {
        var step = items[1].offsetLeft - items[0].offsetLeft;
        if (step) return step;
      }
      return list.clientWidth;
    }
    function cartPairsSync(list) {
      var wrap = list.closest('.cart-pairs');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-cart-pairs-prev]');
      var next = wrap.querySelector('[data-cart-pairs-next]');
      var maxScroll = list.scrollWidth - list.clientWidth;
      if (prev) prev.disabled = list.scrollLeft <= 1;
      if (next) next.disabled = list.scrollLeft >= maxScroll - 1;
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cart-pairs-prev],[data-cart-pairs-next]');
      if (!btn) return;
      var list = cartPairsList(btn);
      if (!list) return;
      var dir = btn.hasAttribute('data-cart-pairs-prev') ? -1 : 1;
      list.scrollBy({ left: dir * cartPairsStep(list), behavior: 'smooth' });
    });

    // Capture phase so the list's own scroll is caught without per-element binding.
    document.addEventListener('scroll', function (event) {
      var list = event.target;
      if (!list.classList || !list.classList.contains('slider')) return;
      if (!list.closest('.cart-pairs')) return;
      cartPairsSync(list);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('rug-compare')) return;

    var DASH = '—';
    var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';


    function idEq(a, b) {
      return String(a) === String(b);
    }

    class RugCompare extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.storageKey = this.dataset.storageKey || 'hh:compare';
        this.compareUrl = this.dataset.compareUrl || '/pages/compare-rugs';
        this.maxDesktop = parseInt(this.dataset.maxDesktop, 10) || 3;
        this.maxMobile = parseInt(this.dataset.maxMobile, 10) || 2;
        this.removeLabel = this.dataset.removeLabel || 'Remove';
        this.removeShort = this.dataset.removeShort || 'Remove';
        this.overviewLabel = this.dataset.overviewLabel || 'Overview';
        this.stepEmpty = this.dataset.stepEmpty || '';
        this.stepMore = this.dataset.stepMore || '';
        this.isOpen = false;

        this.tab = this.querySelector('[data-compare-panel-toggle]');
        this.tabCount = this.querySelector('[data-tab-count]');
        this.listEl = this.querySelector('[data-compare-list]');
        this.goBtn = this.querySelector('[data-compare-go]');
        this.goCount = this.querySelector('[data-go-count]');
        this.clearBtn = this.querySelector('[data-compare-clear]');
        this.needEl = this.querySelector('[data-compare-need]');

        var closeTpl = this.querySelector('[data-tpl-close]');
        this.closeIcon = closeTpl ? closeTpl.innerHTML : '×';

        try {
          this.rows = JSON.parse(this.querySelector('[data-compare-rows]').textContent) || [];
        } catch (e) {
          this.rows = [];
        }

        this.selected = this.readStore();
        this.enforceMax(true);

        this.bind();
        this.syncToggles();
        this.render();

        this.mq = window.matchMedia('(max-width: 749px)');
        var self = this;
        var onMq = function () {
          self.enforceMax();
          self.syncToggles();
          self.render();
        };
        if (this.mq.addEventListener) {
          this.mq.addEventListener('change', onMq);
        } else if (this.mq.addListener) {
          this.mq.addListener(onMq);
        }

        window.addEventListener('storage', function (e) {
          if (e.key !== self.storageKey) return;
          self.selected = self.readStore();
          self.enforceMax(true);
          self.syncToggles();
          self.render();
        });

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () {
            self.syncToggles();
            self.render();
          });
        }
      }

      readStore() {
        var list = [];
        try {
          list = JSON.parse(localStorage.getItem(this.storageKey)) || [];
        } catch (e) {}
        if (!Array.isArray(list)) list = [];
        return list.filter(function (x) {
          return x && x.id != null && x.attrs;
        });
      }

      writeStore() {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(this.selected));
        } catch (e) {}
      }

      currentMax() {
        return this.mq && this.mq.matches ? this.maxMobile : this.maxDesktop;
      }

      atMax() {
        return this.selected.length >= this.currentMax();
      }

      enforceMax(silent) {
        var max = this.currentMax();
        if (this.selected.length > max) {
          this.selected = this.selected.slice(0, max);
          this.writeStore();
          if (!silent) {
            this.syncToggles();
            this.render();
          }
        }
      }

      setOpen(state) {
        this.isOpen = state;
        this.classList.toggle('is-open', state);
        if (this.tab) this.tab.setAttribute('aria-expanded', state ? 'true' : 'false');
      }

      bind() {
        var self = this;

        document.addEventListener('click', function (e) {
          var addBtn = e.target.closest('[data-compare-add]');
          if (addBtn) {
            var item = addBtn.closest('[data-compare-item]');
            if (item) self.onToggle(item);
            return;
          }
          if (e.target.closest('[data-compare-panel-close]')) {
            self.setOpen(false);
            return;
          }
          if (e.target.closest('[data-compare-panel-toggle]')) {
            self.setOpen(!self.isOpen);
            return;
          }
          if (e.target.closest('[data-compare-remove]')) {
            self.removeById(e.target.closest('[data-compare-remove]').dataset.id);
            return;
          }
          if (e.target.closest('[data-compare-clear]')) {
            self.clearAll();
            return;
          }
          if (e.target.closest('[data-compare-go]')) {
            self.goToCompare();
            return;
          }
          // Click outside the panel closes it.
          if (self.isOpen && !e.target.closest('.rc-edge')) {
            self.setOpen(false);
          }
        });

        document.addEventListener('keyup', function (e) {
          if (e.key === 'Escape' && self.isOpen) self.setOpen(false);
        });
      }

      onToggle(item) {
        var id = item.dataset.id;
        if (this.selected.some(function (x) { return idEq(x.id, id); })) {
          this.removeById(id);
          return;
        }
        if (this.atMax()) return;
        var data = this.readItemData(item);
        if (!data) return;
        this.selected.push(data);
        this.writeStore();
        this.syncToggles();
        this.render();

        // Every add slides the panel open.
        var self = this;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { self.setOpen(true); });
        });
      }

      readItemData(item) {
        var node = item.querySelector('[data-compare-data]');
        if (!node) return null;
        try {
          return JSON.parse(node.textContent);
        } catch (e) {
          return null;
        }
      }

      removeById(id) {
        this.selected = this.selected.filter(function (x) { return !idEq(x.id, id); });
        this.writeStore();
        this.syncToggles();
        this.render();
      }

      clearAll() {
        this.selected = [];
        this.writeStore();
        this.setOpen(false);
        this.syncToggles();
        this.render();
      }

      goToCompare() {
        if (this.selected.length < 2) return;
        window.location.href = this.compareUrl;
      }

      syncToggles() {
        var self = this;
        var full = this.atMax();
        document.querySelectorAll('[data-compare-item]').forEach(function (item) {
          var id = item.dataset.id;
          var isSel = self.selected.some(function (x) { return idEq(x.id, id); });
          item.classList.toggle('is-added', isSel);
          var btn = item.querySelector('[data-compare-add]');
          if (btn) {
            btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
            btn.disabled = !isSel && full;
          }
          var addLabel = item.querySelector('[data-add-label]');
          var addedLabel = item.querySelector('[data-added-label]');
          if (addLabel) addLabel.hidden = isSel;
          if (addedLabel) addedLabel.hidden = !isSel;
        });
      }

      render() {
        var self = this;
        var n = this.selected.length;
        var onComparePage = !!document.querySelector('[data-compare-view]');

        // Build the panel list.
        if (this.listEl) {
          this.listEl.innerHTML = '';
          this.selected.forEach(function (it) {
            self.listEl.appendChild(self.buildRow(it));
          });
        }

        if (this.tabCount) this.tabCount.textContent = n ? String(n) : '';
        if (this.goCount) this.goCount.textContent = n >= 2 ? String(n) : '';
        if (this.goBtn) this.goBtn.hidden = n < 2;
        if (this.needEl) this.needEl.hidden = n !== 1;
        if (this.clearBtn) this.clearBtn.hidden = n === 0;

        if (n === 0 || onComparePage) {
          if (this.isOpen) this.setOpen(false);
          this.hidden = true;
        } else {
          this.hidden = false;
        }

        // Render the inline comparison on the compare page.
        var view = document.querySelector('[data-compare-view]');
        if (view) this.renderInline(view);
      }

      buildRow(it) {
        var attrs = it.attrs || {};
        var row = document.createElement('div');
        row.className = 'rc-edge__item';

        var link = document.createElement('a');
        link.className = 'rc-edge__item-link';
        link.href = it.url || '#';

        if (it.image) {
          var img = new Image();
          img.className = 'rc-edge__item-thumb';
          img.src = it.image;
          img.alt = it.title || '';
          img.loading = 'lazy';
          link.appendChild(img);
        }

        var text = document.createElement('div');
        text.className = 'rc-edge__item-text';
        var name = document.createElement('span');
        name.className = 'rc-edge__item-name';
        name.textContent = it.title || '';
        text.appendChild(name);
        if (attrs.price) {
          var price = document.createElement('span');
          price.className = 'rc-edge__item-price';
          price.textContent = attrs.price;
          text.appendChild(price);
        }
        link.appendChild(text);
        row.appendChild(link);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rc-edge__item-remove';
        remove.setAttribute('data-compare-remove', '');
        remove.setAttribute('aria-label', this.removeLabel);
        remove.dataset.id = it.id;
        remove.innerHTML = this.closeIcon;
        row.appendChild(remove);

        return row;
      }

      renderInline(view) {
        var grid = view.querySelector('[data-compare-grid]');
        var toolbar = view.querySelector('[data-compare-toolbar]');
        if (toolbar) toolbar.hidden = this.selected.length === 0;
        if (grid) this.buildComparison(grid);
      }

      buildComparison(grid) {
        var self = this;
        var cols = this.currentMax();
        var activeCount = this.selected.length;

        // Fixed array of `cols` slots: each is a full product object, or null when not added.
        var slots = [];
        for (var s = 0; s < cols; s++) slots.push(this.selected[s] || null);

        grid.style.setProperty('--cols', String(cols));
        grid.innerHTML = '';

        // Header row: "Overview" label + one product/empty header per slot.
        var head = document.createElement('div');
        head.className = 'rcv-headlabel';
        var headInner = document.createElement('span');
        headInner.className = 'rcv-label-inner';
        headInner.textContent = self.overviewLabel;
        head.appendChild(headInner);
        grid.appendChild(head);

        slots.forEach(function (slot) {
          grid.appendChild(slot ? self.buildProductHead(slot) : self.buildEmptyHead(activeCount));
        });

        // Spec rows: label + one value cell per slot (real value when present, "—" when not).
        this.rows.forEach(function (row) {
          var label = document.createElement('div');
          label.className = 'rcv-rowlabel';
          var labelInner = document.createElement('span');
          labelInner.className = 'rcv-label-inner';
          labelInner.textContent = row.label;
          label.appendChild(labelInner);
          grid.appendChild(label);

          slots.forEach(function (slot) {
            var cell = document.createElement('div');
            cell.className = 'rcv-val';
            if (!slot) {
              cell.className += ' rcv-val--empty';
              cell.textContent = DASH;
            } else if (row.key === 'sizes') {
              // Real data: a size → price list.
              cell.className += ' rcv-val--sizes';
              cell.appendChild(self.buildSizeList(slot));
            } else if (row.key === 'price') {
              // Real data: the min–max price range.
              cell.textContent = (slot.attrs && slot.attrs.price) || DASH;
            } else {
              // Real data, wired one row at a time; "—" until wired / when the rug has no value.
              var real = slot.attrs && slot.attrs[row.key];
              cell.textContent = (real != null && String(real).trim() !== '') ? real : DASH;
            }
            grid.appendChild(cell);
          });
        });
      }

      buildProductHead(it) {
        var self = this;
        var head = document.createElement('div');
        head.className = 'rcv-head';

        var images = (it.images && it.images.length) ? it.images : (it.image ? [it.image] : []);
        head.appendChild(self.buildCarousel(images, it.url, it.title));

        var info = document.createElement('div');
        info.className = 'rcv-head__info';

        var name = document.createElement('a');
        name.className = 'rcv-name';
        name.href = it.url || '#';
        name.textContent = it.title || '';
        info.appendChild(name);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rcv-remove';
        remove.setAttribute('data-compare-remove', '');
        remove.setAttribute('aria-label', self.removeLabel);
        remove.dataset.id = it.id;
        remove.textContent = self.removeShort;
        info.appendChild(remove);

        head.appendChild(info);
        return head;
      }

      buildEmptyHead(activeCount) {
        var cell = document.createElement('div');
        cell.className = 'rcv-head rcv-head--empty';
        var msg = document.createElement('span');
        msg.className = 'rcv-empty-msg';
        msg.textContent = activeCount === 0 ? this.stepEmpty : this.stepMore;
        cell.appendChild(msg);
        return cell;
      }

      buildSizeList(slot) {
        var wrap = document.createElement('div');
        wrap.className = 'rcv-sizes';
        var list = slot.variants || [];
        if (!list.length) {
          wrap.textContent = DASH;
          return wrap;
        }
        list.forEach(function (v) {
          var row = document.createElement('div');
          row.className = 'rcv-sizes__row';
          var s = document.createElement('span');
          s.className = 'rcv-sizes__size';
          s.textContent = v.size || '';
          var p = document.createElement('span');
          p.className = 'rcv-sizes__price';
          p.textContent = v.price || '';
          row.appendChild(s);
          row.appendChild(p);
          wrap.appendChild(row);
        });
        return wrap;
      }

      buildCarousel(images, url, title) {
        var wrap = document.createElement('div');
        wrap.className = 'rcv-carousel';

        var track = document.createElement('div');
        track.className = 'rcv-carousel__track';
        (images.length ? images : ['']).forEach(function (src) {
          var cell = document.createElement('a');
          cell.className = 'rcv-carousel__cell';
          cell.href = url || '#';
          if (src) {
            var img = new Image();
            img.src = src;
            img.alt = title || '';
            img.loading = 'lazy';
            cell.appendChild(img);
          }
          track.appendChild(cell);
        });
        wrap.appendChild(track);

        if (images.length > 1) {
          var i = 0;
          var dots = document.createElement('div');
          dots.className = 'rcv-carousel__dots';
          var dotEls = images.map(function (_, k) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'rcv-carousel__dot' + (k === 0 ? ' is-active' : '');
            d.setAttribute('aria-label', 'Image ' + (k + 1));
            dots.appendChild(d);
            return d;
          });
          var go = function (n) {
            i = (n + images.length) % images.length;
            track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          };
          track.addEventListener('scroll', function () {
            var current = Math.round(track.scrollLeft / track.clientWidth) || 0;
            if (current !== i) {
              i = current;
              dotEls.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
            }
          });
          var prev = document.createElement('button');
          prev.type = 'button';
          prev.className = 'rcv-carousel__nav rcv-carousel__nav--prev';
          prev.setAttribute('aria-label', 'Previous image');
          prev.innerHTML = CHEVRON;
          var next = document.createElement('button');
          next.type = 'button';
          next.className = 'rcv-carousel__nav rcv-carousel__nav--next';
          next.setAttribute('aria-label', 'Next image');
          next.innerHTML = CHEVRON;
          prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(i - 1); });
          next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(i + 1); });
          dotEls.forEach(function (d, k) {
            d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(k); });
          });
          wrap.appendChild(prev);
          wrap.appendChild(next);
          wrap.appendChild(dots);
        }
        return wrap;
      }
    }

    customElements.define('rug-compare', RugCompare);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fbt-products"] && !Shopify.designMode) return;
  try {
    class FbtBundle extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fbt-track]');
      this.dotsEl = this.querySelector('[data-fbt-dots]');
      this.navEl = this.querySelector('[data-fbt-nav]');
      this.prevBtn = this.querySelector('[data-fbt-prev]');
      this.nextBtn = this.querySelector('[data-fbt-next]');
      this.activeIndex = 0;
      this.dialog = this.querySelector('[data-fbt-dialog]');
      this.descEl = this.querySelector('[data-fbt-desc]');
      this.moreBtn = this.querySelector('[data-fbt-more]');
      this.moreBtn.addEventListener('click', () => {
        const open = !this.descEl.classList.contains('is-open');
        this.descEl.classList.toggle('is-open', open);
        this.moreBtn.setAttribute('aria-expanded', String(open));
        this.moreBtn.textContent = open ? this.moreBtn.dataset.less : this.moreBtn.dataset.more;
        this.syncDescMore();
      });
      this.galleryEl = this.querySelector('[data-fbt-gallery]');
      this.optionsEl = this.querySelector('[data-fbt-options]');
      this.confirmBtn = this.querySelector('[data-fbt-confirm]');
      this.viewLink = this.querySelector('[data-fbt-view]');
      this.counterEl = this.querySelector('[data-fbt-counter]');
      this.rugVariants = JSON.parse(this.querySelector('[data-fbt-rug-variants]').textContent);
      this.sheet = null; // { product, selected: [values], recommendedId } while the drawer is open

      this.track.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-fbt-quick-add]');
        if (btn) this.onQuickAdd(btn);
      });
      this.dotsEl.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-index]');
        if (dot) this.goTo(Number(dot.dataset.index));
      });
      this.prevBtn.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      this.nextBtn.addEventListener('click', () => this.goTo(this.activeIndex + 1));
      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

      this.galleryEl.addEventListener('scroll', () => this.updateCounter(), { passive: true });
      this.optionsEl.addEventListener('click', (e) => {
        const pill = e.target.closest('[data-option-index]');
        if (!pill || !this.sheet) return;
        this.selectOption(Number(pill.dataset.optionIndex), pill.dataset.value);
        const group = pill.closest('[role="radiogroup"]');
        const checked = group && group.querySelector('[aria-checked="true"]');
        if (checked) checked.focus();
      });
      this.confirmBtn.addEventListener('click', () => {
        const variant = this.sheet && this.currentVariant();
        if (!variant || !variant.available) return;
        this.addItems([{ id: variant.id, quantity: 1 }], this.confirmBtn).then((ok) => {
          if (ok) this.closeDrawer();
        });
      });
      this.querySelector('[data-fbt-dialog-close]').addEventListener('click', () => this.closeDrawer());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.closeDrawer();
      });
      // Esc: slide out like the other close paths instead of vanishing.
      this.dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.closeDrawer();
      });
      this.dialog.addEventListener('close', () => {
        this.dialog.classList.remove('is-open');
        document.body.style.overflow = this.prevBodyOverflow || '';
        this.sheet = null;
      });

      this.renderDots();
      if (this.dataset.recsUrl) this.loadComplementary();
    }

    cards() {
      return Array.from(this.track.querySelectorAll('[data-fbt-card]'));
    }

    // Swap in Search & Discovery complementary products. The bundle stays
    // hidden until this resolves (no flash of the fallback); with none, the
    // collection fallback shows, or the block stays hidden if that is empty.
    loadComplementary() {
      fetch(this.dataset.recsUrl)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const result = doc.querySelector('[data-fbt-recs-result="' + this.dataset.blockId + '"]');
          if (result && result.querySelector('[data-fbt-card]')) this.track.innerHTML = result.innerHTML;
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.hidden = !this.cards().length;
          this.renderDots();
        });
    }

    goTo(index) {
      const card = this.cards()[index];
      if (card) this.track.scrollTo({ left: this.cardScrollLeft(card), behavior: 'smooth' });
    }

    // One card: full width, no carousel controls. Two or more: carousel.
    renderDots() {
      const count = this.cards().length;
      this.classList.toggle('fbt-block--carousel', count > 1);
      this.navEl.hidden = count < 2;
      this.dotsEl.innerHTML = '';
      this.dotsEl.hidden = count < 2;
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fbt-block__dot';
        dot.dataset.index = i;
        dot.setAttribute('aria-label', String(i + 1) + ' ' + this.dotsEl.dataset.of + ' ' + count);
        this.dotsEl.appendChild(dot);
      }
      this.onScroll();
    }

    // scrollLeft at which a card sits at the snap point (track padding included).
    cardScrollLeft(card) {
      const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      return card.offsetLeft - this.track.offsetLeft - pad;
    }

    // Active dot = the card whose snap position is closest to the current scroll.
    onScroll() {
      const cards = this.cards();
      if (!cards.length) return;
      const left = this.track.scrollLeft;
      let active = 0;
      cards.forEach((card, i) => {
        if (Math.abs(this.cardScrollLeft(card) - left) < Math.abs(this.cardScrollLeft(cards[active]) - left)) {
          active = i;
        }
      });
      // At the far end, the last card can't snap to the left edge.
      if (left + this.track.clientWidth >= this.track.scrollWidth - 2) active = cards.length - 1;
      this.activeIndex = active;
      this.dotsEl.querySelectorAll('.fbt-block__dot').forEach((dot, i) => {
        dot.setAttribute('aria-current', String(i === active));
      });
      this.prevBtn.disabled = active === 0;
      this.nextBtn.disabled = active === cards.length - 1;
    }

    onQuickAdd(btn) {
      const card = btn.closest('[data-fbt-card]');
      const product = JSON.parse(card.querySelector('[data-fbt-product]').textContent);
      if (!product.variants.length) return;
      this.openDrawer(product);
    }

    parseDims(str) {
      const m = String(str).match(/(\d+)\s*x\s*(\d+)/i);
      if (!m) return null;
      const a = Number(m[1]);
      const b = Number(m[2]);
      return [Math.min(a, b), Math.max(a, b)];
    }

    currentRug() {
      const scope = this.closest('product-info') || document;
      const input = scope.querySelector('.product-variant-id');
      return input ? this.rugVariants.find((v) => String(v.id) === String(input.value)) || null : null;
    }

    // Largest available size that fits inside the selected rug (null if sizes aren't dimensions).
    recommended(product) {
      const rug = this.currentRug();
      const r = rug && this.parseDims(rug.dims);
      if (!r) return null;
      let best = null;
      let bestArea = 0;
      product.variants.forEach((v) => {
        const d = this.parseDims(v.dims);
        if (!v.available || !d || d[0] > r[0] || d[1] > r[1]) return;
        if (d[0] * d[1] > bestArea) {
          best = v;
          bestArea = d[0] * d[1];
        }
      });
      return best;
    }

    openDrawer(product) {
      const rec = this.recommended(product);
      const start = rec || product.variants.find((v) => v.available) || product.variants[0];
      this.sheet = { product, selected: start.options.slice(), recommendedId: rec ? rec.id : null };

      this.querySelector('[data-fbt-title]').textContent = product.title;
      // Description as the product's own HTML, collapsed; "Read more" opens it.
      const descHtml = product.descriptionHtml || '';
      this.querySelector('[data-fbt-desc-wrap]').hidden = !descHtml.trim();
      this.descEl.innerHTML = descHtml;
      this.descEl.classList.remove('is-open');
      this.moreBtn.setAttribute('aria-expanded', 'false');
      this.moreBtn.textContent = this.moreBtn.dataset.more;

      this.renderGallery();
      this.renderDrawer();

      this.prevBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      // Next frame, so the transform transition runs (as the cart drawer's .active does).
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      this.syncDescMore();
      // Always open on the first image; option changes jump to the variant's image.
      this.galleryEl.scrollLeft = 0;
      this.querySelector('.fbt-drawer__body').scrollTop = 0;
      this.updateCounter();
    }

    // "Read more" only when the description is longer than the collapsed height.
    syncDescMore() {
      const clamped = !this.descEl.classList.contains('is-open') && this.descEl.scrollHeight > this.descEl.clientHeight + 1;
      this.descEl.classList.toggle('is-clamped', clamped);
      this.moreBtn.hidden = !clamped && !this.descEl.classList.contains('is-open');
    }

    // Slide out (cart-drawer timing), then close the dialog.
    closeDrawer() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const duration = parseFloat(getComputedStyle(this.dialog).transitionDuration) * 1000 || 0;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (!this.dialog.classList.contains('is-open')) this.dialog.close();
      }, reduce ? 0 : duration);
    }

    renderGallery() {
      const { product } = this.sheet;
      this.galleryEl.innerHTML = '';
      this.galleryEl.classList.toggle('fbt-drawer__gallery--single', product.images.length < 2);
      this.counterEl.hidden = product.images.length < 2;
      product.images.forEach((image, i) => {
        const slide = document.createElement('div');
        slide.className = 'fbt-drawer__slide';
        slide.dataset.mediaId = image.id;
        const img = document.createElement('img');
        img.src = image.src;
        img.alt = image.alt || '';
        img.width = 900;
        img.height = 900;
        img.loading = i < 2 ? 'eager' : 'lazy';
        slide.appendChild(img);
        this.galleryEl.appendChild(slide);
      });
    }

    // "2 / 5": the slide nearest the gallery's snap edge.
    updateCounter() {
      const slides = this.galleryEl.querySelectorAll('.fbt-drawer__slide');
      if (slides.length < 2) return;
      const pad = parseFloat(getComputedStyle(this.galleryEl).paddingLeft) || 0;
      const left = this.galleryEl.scrollLeft;
      let active = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - this.galleryEl.offsetLeft - pad - left);
        if (dist < best) {
          best = dist;
          active = i;
        }
      });
      if (left + this.galleryEl.clientWidth >= this.galleryEl.scrollWidth - 2) active = slides.length - 1;
      this.counterEl.textContent = active + 1 + ' / ' + slides.length;
    }

    // Variant matching every selected option value.
    currentVariant() {
      const { product, selected } = this.sheet;
      return product.variants.find((v) => v.options.every((value, i) => value === selected[i])) || null;
    }

    // Is there an available variant with this value, keeping the other selected values?
    valueAvailable(index, value) {
      const { product, selected } = this.sheet;
      return product.variants.some(
        (v) => v.available && v.options[index] === value && v.options.every((o, i) => i === index || o === selected[i])
      );
    }

    selectOption(index, value) {
      const { product, selected } = this.sheet;
      selected[index] = value;
      // If that combination doesn't exist / is sold out, jump to the closest available one.
      const exact = this.currentVariant();
      if (!exact || !exact.available) {
        const fallback = product.variants.find((v) => v.available && v.options[index] === value);
        if (fallback) this.sheet.selected = fallback.options.slice();
      }
      this.renderDrawer();
      this.scrollToVariantImage();
    }

    scrollToVariantImage() {
      const variant = this.currentVariant();
      if (!variant || !variant.mediaId) return;
      const slide = this.galleryEl.querySelector('[data-media-id="' + variant.mediaId + '"]');
      if (!slide) return;
      const pad = parseFloat(getComputedStyle(this.galleryEl).paddingLeft) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.galleryEl.scrollTo({
        left: slide.offsetLeft - this.galleryEl.offsetLeft - pad,
        behavior: reduce ? 'auto' : 'smooth',
      });
    }

    renderDrawer() {
      const { product, selected, recommendedId } = this.sheet;
      const variant = this.currentVariant();

      // Options
      this.optionsEl.innerHTML = '';
      const hasOptions = !(product.variants.length === 1 && product.options.length === 1 && product.options[0] === 'Title');
      if (hasOptions) {
        const rec = recommendedId && product.variants.find((v) => v.id === recommendedId);
        product.options.forEach((name, index) => {
          const group = document.createElement('div');
          group.className = 'fbt-drawer__option';
          const label = document.createElement('span');
          label.className = 'fbt-drawer__label';
          label.id = this.dialog.getAttribute('aria-labelledby') + '-opt' + index;
          label.textContent = name;
          const pills = document.createElement('div');
          pills.className = 'fbt-drawer__pills';
          pills.setAttribute('role', 'radiogroup');
          pills.setAttribute('aria-labelledby', label.id);

          const values = [];
          product.variants.forEach((v) => {
            if (!values.includes(v.options[index])) values.push(v.options[index]);
          });
          values.forEach((value) => {
            const pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'fbt-drawer__size';
            pill.dataset.optionIndex = index;
            pill.dataset.value = value;
            pill.setAttribute('role', 'radio');
            pill.setAttribute('aria-checked', String(selected[index] === value));
            if (!this.valueAvailable(index, value)) pill.classList.add('is-unavailable');
            pill.textContent = value;
            if (index === 0 && rec && rec.options[0] === value) {
              const tag = document.createElement('span');
              tag.className = 'fbt-drawer__size-tag';
              tag.textContent = this.optionsEl.dataset.recommendedLabel;
              pill.appendChild(tag);
            }
            pills.appendChild(pill);
          });

          group.append(label, pills);
          if (index === 0 && rec) {
            const rug = this.currentRug();
            if (rug) {
              const note = document.createElement('p');
              note.className = 'fbt-drawer__note';
              note.textContent = this.optionsEl.dataset.rugTemplate.replace('__SIZE__', rug.dims);
              group.appendChild(note);
            }
          }
          this.optionsEl.appendChild(group);
        });
      }

      // Pricing
      this.querySelector('[data-fbt-price]').textContent = variant ? variant.priceText : '';
      this.querySelector('[data-fbt-struck]').textContent = variant ? variant.struckText : '';
      const badge = this.querySelector('[data-fbt-badge]');
      badge.hidden = !product.appliedPct;
      if (product.appliedPct) badge.textContent = badge.dataset.template.replace('__PCT__', product.appliedPct);

      const afterpay = this.querySelector('[data-fbt-afterpay]');
      afterpay.hidden = !variant;
      if (variant) {
        const parts = afterpay.dataset.template.split('__AMOUNT__');
        const text = this.querySelector('[data-fbt-afterpay-text]');
        text.textContent = '';
        const amount = document.createElement('strong');
        amount.textContent = variant.afterpayText;
        text.append(parts[0], amount, parts[1] || '');
      }

      // Stock
      const stock = this.querySelector('[data-fbt-stock]');
      const state = variant ? variant.stock : 'out';
      stock.dataset.state = state;
      stock.textContent = stock.dataset[state];

      // Footer
      const available = !!(variant && variant.available);
      this.confirmBtn.disabled = !available;
      this.querySelector('[data-fbt-confirm-label]').textContent = available
        ? this.confirmBtn.dataset.addLabel
        : this.confirmBtn.dataset.soldOutLabel;
      this.viewLink.href = variant ? product.url + (product.url.includes('?') ? '&' : '?') + 'variant=' + variant.id : product.url;
    }

    // AJAX add (same pattern as product-form.js); resolves true on success.
    addItems(items, btn) {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      const spinner = btn.querySelector('.loading__spinner');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error(response);
            return false;
          }
          // Clear the empty-cart state (mirrors product-form.js); otherwise the
          // drawer's focus trap targets the removed empty-state markup.
          if (cart && cart.classList && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
          return true;
        })
        .catch((e) => {
          console.error(e);
          return false;
        })
        .finally(() => {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }
  }

  if (!customElements.get('fbt-bundle')) {
    customElements.define('fbt-bundle', FbtBundle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["in-stock-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('in-stock-toggle')) {
    customElements.define(
      'in-stock-toggle',
      class InStockToggle extends HTMLElement {
        connectedCallback() {
          if (this._bound) return;
          this._bound = true;
          this.input = this.querySelector('input');
          if (!this.input) return;
          // The switch submits itself; keep its events from also firing the
          // surrounding filter form's own submit.
          this.input.addEventListener('input', (event) => event.stopPropagation());
          this.input.addEventListener('change', (event) => {
            event.stopPropagation();
            const on = this.input.checked;
            // The desktop and mobile switches are both in the page: keep them in step.
            document.querySelectorAll('in-stock-toggle input').forEach((input) => {
              input.checked = on;
            });
            const params = new URLSearchParams(window.location.search);
            params.delete('page');
            if (on) {
              params.set('filter.v.availability', '1');
            } else {
              params.delete('filter.v.availability');
            }
            if (typeof FacetFiltersForm !== 'undefined') {
              FacetFiltersForm.renderPage(params.toString(), null, true);
            } else {
              window.location.search = params.toString();
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-rating-float"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'kr-float-dismissed';
    var IDLE_MS = 2000;
    var el = document.querySelector('[data-kr-float]');
    if (!el) return;

    var dismissed = false;
    try {
      dismissed = sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {}

    if (dismissed) {
      el.hidden = true;
      return;
    }

    var idleTimer = null;

    function show() {
      if (dismissed) return;
      el.classList.add('is-visible');
    }

    function hide() {
      el.classList.remove('is-visible');
    }

    // Visible on landing (next frame so the entrance transition plays).
    requestAnimationFrame(show);

    window.addEventListener(
      'scroll',
      function () {
        if (dismissed) return;
        hide();
        if (idleTimer) clearTimeout(idleTimer);
        idleTimer = setTimeout(show, IDLE_MS);
      },
      { passive: true }
    );

    var closeBtn = el.querySelector('[data-kr-float-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        dismissed = true;
        el.hidden = true;
        if (idleTimer) clearTimeout(idleTimer);
        hide();
        try {
          sessionStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {}
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-afterpay"] && !Shopify.designMode) return;
  try {
    class PdpAfterpayModal extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this._onKey = (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') this.close();
      };

      // Delegated open: attached unconditionally so it works even if
      // connectedCallback runs before children are parsed, and survives
      // product-info.js replacing #afterpay-<id>'s innerHTML on variant change.
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-ap-open]')) {
          event.preventDefault();
          this.open();
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      if (this.overlay && this.overlay.parentElement === document.body) {
        this.overlay.remove();
      }
    }

    // Resolve the overlay lazily (on first open), then move it to <body> so no
    // transformed/overflow ancestor can clip it and it stacks above the page.
    ensureOverlay() {
      if (this.overlay) return this.overlay;
      this.overlay = this.querySelector('[data-ap-overlay]');
      if (!this.overlay) return null;
      document.body.appendChild(this.overlay);
      this.overlay.addEventListener('click', (event) => {
        if (event.target === this.overlay || event.target.closest('[data-ap-close]')) {
          this.close();
        }
      });
      return this.overlay;
    }

    open() {
      const overlay = this.ensureOverlay();
      if (!overlay) return;
      overlay.classList.add('is-open');
      document.body.classList.add('pdp-ap-modal-open');
      document.addEventListener('keydown', this._onKey);
      const closeBtn = overlay.querySelector('[data-ap-close]');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      if (!this.overlay) return;
      this.overlay.classList.remove('is-open');
      document.body.classList.remove('pdp-ap-modal-open');
      document.removeEventListener('keydown', this._onKey);
    }
  }

  if (!customElements.get('pdp-afterpay-modal')) {
    customElements.define('pdp-afterpay-modal', PdpAfterpayModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-reels')) {
    customElements.define(
      'pdp-reels',
      class PdpReels extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-reel-dialog]');
          this.video = this.querySelector('[data-reel-video]');
          this.handle = this.querySelector('[data-reel-handle]');
          this.soundBtn = this.querySelector('[data-reel-sound]');
          this.fills = Array.from(this.querySelectorAll('.pdp-reels__segment'));
          this.reels = Array.from(this.querySelector('[data-reel-sources]').content.children).map((el) => ({
            src: el.dataset.src,
            handle: el.dataset.handle,
          }));
          this.tile = this.querySelector('[data-reel-tile]');
          this.tileVideo = this.tile.querySelector('video');
          this.tileSegments = Array.from(this.tile.querySelectorAll('.pdp-reels__tile-segment'));
          this.tileIndex = 0;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.index = 0;
          this.muted = false;

          this.querySelectorAll('[data-reel-open]').forEach((btn) =>
            btn.addEventListener('click', () => this.open(Number(btn.dataset.reelOpen)))
          );
          this.querySelectorAll('[data-reel-prev]').forEach((btn) =>
            btn.addEventListener('click', () => this.go(this.index - 1))
          );
          this.querySelectorAll('[data-reel-next]').forEach((btn) =>
            btn.addEventListener('click', () => this.go(this.index + 1))
          );
          this.querySelector('[data-reel-close]').addEventListener('click', () => this.dialog.close());
          this.querySelector('[data-reel-shop]').addEventListener('click', () => this.shop());
          this.soundBtn.addEventListener('click', () => this.setMuted(!this.muted));

          this.dialog.addEventListener('close', () => this.onClose());
          this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') this.go(this.index - 1);
            if (e.key === 'ArrowRight') this.go(this.index + 1);
          });

          this.video.addEventListener('timeupdate', () => this.paintProgress());
          this.video.addEventListener('ended', () => {
            if (this.index < this.reels.length - 1) this.go(this.index + 1);
            else this.video.play();
          });

          // One frame, every reel: when a clip ends the frame fades to the next, so
          // a second video costs no extra space. With one video it just loops.
          if (this.reels.length > 1) {
            this.tileVideo.addEventListener('ended', () => this.advanceTile());
          }

          // The frame only plays while the card is on screen; off screen it would just burn data.
          if (!this.reduceMotion && 'IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              ([entry]) => {
                this.inView = entry.isIntersecting;
                if (this.inView && !this.dialog.open) this.tileVideo.play().catch(() => {});
                else this.tileVideo.pause();
              },
              { threshold: 0.4 }
            );
            this.observer.observe(this);
          }
        }

        advanceTile() {
          this.tileIndex = (this.tileIndex + 1) % this.reels.length;
          this.tile.dataset.reelOpen = this.tileIndex;
          this.tileSegments.forEach((seg, i) => seg.classList.toggle('is-active', i <= this.tileIndex));
          this.tile.classList.add('is-swapping');
          setTimeout(() => {
            this.tileVideo.src = `${this.reels[this.tileIndex].src}#t=0.001`;
            this.tileVideo.play().catch(() => {});
            this.tileVideo.addEventListener('playing', () => this.tile.classList.remove('is-swapping'), { once: true });
          }, 300);
        }

        open(index) {
          this.tileVideo.pause();
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.go(index);
        }

        go(index) {
          if (index < 0 || index >= this.reels.length) return;
          this.index = index;
          const reel = this.reels[index];
          this.video.src = reel.src;
          this.video.muted = this.muted;
          this.video.play().catch(() => this.setMuted(true, true));
          this.handle.textContent = reel.handle;
          this.fills.forEach((seg, i) => {
            seg.classList.toggle('is-done', i < index);
            seg.querySelector('.pdp-reels__segment-fill').style.transform = i < index ? 'scaleX(1)' : 'scaleX(0)';
          });
          this.querySelectorAll('.pdp-reels__arrow--prev').forEach((b) => (b.disabled = index === 0));
          this.querySelectorAll('.pdp-reels__arrow--next').forEach((b) => (b.disabled = index === this.reels.length - 1));
        }

        paintProgress() {
          const fill = this.fills[this.index]?.querySelector('.pdp-reels__segment-fill');
          if (fill && this.video.duration) fill.style.transform = `scaleX(${this.video.currentTime / this.video.duration})`;
        }

        // Browsers refuse autoplay with sound until the page has had a gesture; fall back to muted.
        setMuted(muted, retry) {
          this.muted = muted;
          this.video.muted = muted;
          this.classList.toggle('is-muted', muted);
          this.soundBtn.setAttribute('aria-label', muted ? this.soundBtn.dataset.labelUnmute : this.soundBtn.dataset.labelMute);
          if (retry) this.video.play().catch(() => {});
        }

        shop() {
          this.dialog.close();
          const section = this.closest('section') || document;
          const target =
            section.querySelector('variant-selects, variant-radios, .product-form__input') ||
            section.querySelector('product-form');
          if (target) target.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }

        onClose() {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          document.body.style.overflow = '';
          if (this.inView && !this.reduceMotion) this.tileVideo.play().catch(() => {});
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["preorder-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    function gate() {
      document.querySelectorAll('.product-form__submit').forEach(function (btn) {
        var scope = btn.closest('.shopify-section');
        if (!scope) return;

        var isPreorder = btn.hasAttribute('data-preorder');

        // Dibs relabels the button after Liquid has rendered the correct text.
        // Skipped when the theme has injected a price into the label.
        var intended = btn.getAttribute('data-intended-label');
        var labelEl = btn.querySelector('span');
        if (
          intended &&
          labelEl &&
          !labelEl.querySelector('[id^="btn-price-"]') &&
          labelEl.textContent.trim() !== intended
        ) {
          labelEl.textContent = intended;
        }

        var carrier = scope.querySelector('[data-deferred-plans]');
        // Built-in pre-orders: full payment only, so no Dibs plan may submit on any variant.
        var builtin = !!(carrier && carrier.hasAttribute('data-builtin-preorder'));
        var allowPlan = isPreorder && !builtin;

        // The load-bearing half: without this the deposit still submits.
        scope.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
          if (input.disabled === !allowPlan) return;
          input.disabled = !allowPlan;
        });

        // Pre-order note (buy-buttons.liquid): submits only on a pre-order variant.
        scope.querySelectorAll('[data-preorder-property]').forEach(function (input) {
          if (input.disabled === !isPreorder) return;
          input.disabled = !isPreorder;
        });

        // Full vs Partial, published for the CSS above. Read AFTER the disabling pass,
        // so a plan left over from a pre-order variant can't mark an in-stock one.
        var deferred = carrier ? carrier.getAttribute('data-deferred-plans').split(',') : [];
        var planEl =
          scope.querySelector('[name="selling_plan"]:checked') || scope.querySelector('[name="selling_plan"]');
        var isPartial = false;
        if (isPreorder && planEl && !planEl.disabled && planEl.value) {
          isPartial = deferred.indexOf(String(planEl.value)) !== -1;
        }

        if (isPartial) {
          if (scope.getAttribute('data-preorder-payment') !== 'partial') {
            scope.setAttribute('data-preorder-payment', 'partial');
          }
        } else if (scope.hasAttribute('data-preorder-payment')) {
          scope.removeAttribute('data-preorder-payment');
        }
      });
    }

    gate();
    document.addEventListener('DOMContentLoaded', gate);

    // Dibs switches plans by assigning `input.value`, which mutates no attribute and so
    // raises no mutation record. The radio's own change event is the only reliable cue.
    document.addEventListener('change', gate);

    // Dibs injects and relabels asynchronously, and the theme swaps parts of the
    // section on variant change. Every write above is guarded by a "does it already
    // match" check, so this settles after one pass instead of looping.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.addedNodes.length || r.type === 'characterData' || r.type === 'attributes') return gate();
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-preorder', 'data-intended-label', 'data-selected-selling-plan-id'],
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('.gallery-share-button');
    if (!button) return;

    var shareUrl = button.dataset.shareUrl;
    var shareTitle = button.dataset.shareTitle;

    if (navigator.share) {
      navigator.share({ title: shareTitle, url: shareUrl }).catch(function () {});
      return;
    }

    var label = button.querySelector('.gallery-action-button__text');

    function confirmCopied() {
      if (!label || button.dataset.shareBusy) return;
      button.dataset.shareBusy = 'true';
      var original = label.textContent;
      label.textContent = 'Link copied!';
      setTimeout(function () {
        label.textContent = original;
        delete button.dataset.shareBusy;
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl).then(confirmCopied).catch(function () {
        window.prompt('Copy this link', shareUrl);
      });
    } else {
      window.prompt('Copy this link', shareUrl);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-setup-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('setup-selector')) {
    customElements.define(
      'setup-selector',
      class SetupSelector extends HTMLElement {
        connectedCallback() {
          this.pads = JSON.parse(this.querySelector('[data-pads]').textContent);
          this.rugVariants = JSON.parse(this.querySelector('[data-rug-variants]').textContent);
          this.form = document.getElementById(this.dataset.formId);
          this.cardsEl = this.querySelector('[data-pad-cards]');
          this.listEl = this.querySelector('.setup-selector__list');
          this.onlyCard = this.querySelector('[data-setup="only"]');
          this.errorEl = this.querySelector('[data-setup-error]');
          this.dialog = this.querySelector('[data-pad-dialog]');
          this.galleryWrap = this.querySelector('[data-pad-gallery-wrap]');
          this.galleryEl = this.querySelector('[data-pad-gallery]');
          this.galleryCount = this.querySelector('[data-pad-gallery-count]');
          this.galleryPrev = this.querySelector('[data-pad-gallery-prev]');
          this.galleryNext = this.querySelector('[data-pad-gallery-next]');
          this.galleryPadId = null;
          this.aboutEl = this.querySelector('[data-pad-about]');
          this.descEl = this.querySelector('[data-pad-desc]');
          this.moreBtn = this.querySelector('[data-pad-more]');

          // "Why add a pad?" drawer: slides in / out like the cart drawer.
          this.whyDialog = this.querySelector('[data-setup-why]');
          this.whyOpen = this.querySelector('[data-setup-why-open]');
          this.whyOpen.addEventListener('click', () => this.openWhy());
          this.querySelector('[data-setup-why-close]').addEventListener('click', () => this.closeWhy());
          this.whyDialog.addEventListener('click', (e) => {
            if (e.target === this.whyDialog) this.closeWhy();
          });
          this.whyDialog.addEventListener('cancel', (e) => {
            e.preventDefault();
            this.closeWhy();
          });
          this.whyDialog.addEventListener('close', () => {
            this.whyDialog.classList.remove('is-open');
            document.body.style.overflow = this.prevWhyOverflow || '';
            this.whyOpen.focus();
          });

          this.moreBtn.addEventListener('click', () => {
            const open = !this.descEl.classList.contains('is-open');
            this.descEl.classList.toggle('is-open', open);
            this.moreBtn.setAttribute('aria-expanded', String(open));
            this.moreBtn.textContent = open ? this.moreBtn.dataset.less : this.moreBtn.dataset.more;
          });
          this.galleryEl.addEventListener('scroll', () => this.updateGallery(), { passive: true });
          this.galleryPrev.addEventListener('click', () => this.stepGallery(-1));
          this.galleryNext.addEventListener('click', () => this.stepGallery(1));

          // One row per pad group (custom.pad_group or short name), by rank.
          this.groups = this.buildGroups();
          // Per group: the size picked in its dropdown (variant id); null = the
          // matched size. Reset when the rug size changes.
          this.choice = {};
          this.groups.forEach((g) => (this.choice[g.key] = null));
          // Chosen group (at most one); empty = rug only.
          this.selected = new Set();
          // Group shown in the details dialog.
          this.editing = null;
          // "Show more" (mobile only) open: every pad shows; closed: only the
          // lead (top) one. Desktop always shows every pad.
          this.expanded = false;
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.mobileQuery.addEventListener('change', () => this.renderCards());
          this.moreToggle = this.querySelector('[data-pad-more-toggle]');
          this.moreToggle.addEventListener('mousedown', (e) => e.preventDefault());
          this.moreToggle.addEventListener('click', () => this.toggleMore());

          // Rows are already rendered by Liquid for the starting rug size; only
          // build them here if they weren't.
          if (!this.cardsEl.hasAttribute('data-server-rendered') || !this.cardsEl.children.length) {
            this.renderCards();
          }
          this.cardsEl.removeAttribute('data-server-rendered');
          const more = this.cardsEl.querySelector('[data-pad-extra]');
          more.classList.toggle('is-open', this.moreOpen());
          more.inert = !this.moreOpen();

          // Mouse: select without moving focus onto the row, so no focus ring
          // appears on click. The dropdown and buttons still take focus.
          this.cardsEl.addEventListener('mousedown', (e) => {
            if (!e.target.closest('button, select, label')) e.preventDefault();
          });
          if (this.onlyCard) this.onlyCard.addEventListener('mousedown', (e) => e.preventDefault());
          this.cardsEl.addEventListener('click', (e) => {
            const row = e.target.closest('[data-group]');
            if (!row || e.target.closest('.setup-selector__select')) return;
            if (e.target.closest('[data-pad-change]')) {
              e.stopPropagation();
              this.openDialog(row.dataset.group);
              return;
            }
            this.choose(row.dataset.group);
          });
          if (this.onlyCard) this.onlyCard.addEventListener('click', () => this.choose(null));
          // Picking a size in a row's dropdown uses that size and chooses the pad.
          this.cardsEl.addEventListener('change', (e) => {
            const select = e.target.closest('[data-pad-size]');
            if (!select) return;
            e.stopPropagation();
            const key = select.closest('[data-group]').dataset.group;
            this.choice[key] = select.value;
            // An in-stock size chooses the pad; a sold-out one can't be chosen.
            if (this.isAvailable(this.selection(key))) {
              this.selected.clear();
              this.selected.add(key);
            } else {
              this.selected.delete(key);
            }
            this.renderCards();
          });
          // Space / Enter choose (or, without "Rug only", toggle) the focused card.
          this.listEl.addEventListener('keydown', (e) => {
            const card = e.target.closest('[role="radio"], [role="checkbox"]');
            if (!card || e.target !== card || (e.key !== ' ' && e.key !== 'Enter')) return;
            e.preventDefault();
            this.choose(card.dataset.group || null);
          });

          this.querySelector('[data-pad-confirm]').addEventListener('click', () => {
            if (!this.editing) return;
            const current = this.selection(this.editing);
            if (!this.isAvailable(current)) return;
            this.choice[this.editing] = String(current.variant.id);
            this.selected.clear();
            this.selected.add(this.editing);
            this.renderCards();
            this.dialog.close();
          });
          this.querySelector('[data-pad-dialog-close]').addEventListener('click', () => this.dialog.close());
          // Backdrop click: the dialog element itself is only the target outside its content.
          this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => {
            document.body.style.overflow = this.prevBodyOverflow || '';
            const link = this.editing && this.cardsEl.querySelector('[data-group="' + this.editing + '"] [data-pad-change]');
            this.editing = null;
            if (link) link.focus();
          });

          if (this.form) {
            this.form.addEventListener('change', () => this.onRugChange());
            const submit = this.form.querySelector('.product-form__submit');
            if (submit) submit.addEventListener('click', (e) => this.onSubmit(e), true);
          }
          this.lastRugId = this.currentRugId();
        }

        buildGroups() {
          const groups = [];
          this.pads
            .filter((pad) => pad.variants.length)
            .forEach((pad) => {
              const key = String(pad.group || pad.short || pad.title).trim().toLowerCase();
              let group = groups.find((g) => g.key === key);
              if (!group) {
                group = { key, name: pad.group || pad.short || pad.title, pads: [] };
                groups.push(group);
              }
              group.pads.push(pad);
              group.rank = Math.min(group.rank || 99, pad.rank || 99);
            });
          groups.forEach((group) => (group.options = this.optionsFor(group)));
          // Fixed row order by rank (collection order breaks ties).
          return groups.sort((a, b) => a.rank - b.rank);
        }

        // Every size across the group's pads (sold-out ones too), by width, then
        // length, then in stock first, then price; a size offered by two pads
        // appears once (the in-stock, then cheaper one).
        optionsFor(group) {
          const all = [];
          group.pads.forEach((pad) => pad.variants.forEach((variant) => all.push({ pad, variant })));
          const dims = (o) => this.parseDims(o.variant.dims) || [0, 0];
          const out = (o) => (o.variant.available === false ? 1 : 0);
          all.sort(
            (a, b) =>
              dims(a)[0] - dims(b)[0] || dims(a)[1] - dims(b)[1] || out(a) - out(b) || a.variant.price - b.variant.price
          );
          const seen = new Set();
          return all.filter((o) => {
            if (seen.has(o.variant.dims)) return false;
            seen.add(o.variant.dims);
            return true;
          });
        }

        group(key) {
          return this.groups.find((g) => g.key === key);
        }

        parseDims(str) {
          const m = String(str).match(/(\d+)\s*x\s*(\d+)/i);
          if (!m) return null;
          const a = Number(m[1]);
          const b = Number(m[2]);
          return [Math.min(a, b), Math.max(a, b)];
        }

        area(variant) {
          const d = this.parseDims(variant.dims);
          return d ? d[0] * d[1] : 0;
        }

        currentRugId() {
          const idInput = this.form && this.form.querySelector('.product-variant-id');
          return idInput ? String(idInput.value) : null;
        }

        currentRug() {
          const id = this.currentRugId();
          return (id && this.rugVariants.find((v) => String(v.id) === id)) || null;
        }

        rugDims() {
          const rug = this.currentRug();
          return rug ? this.parseDims(rug.dims) : null;
        }

        isAvailable(option) {
          return !!option && option.variant.available !== false;
        }

        // Preset size: in range (up to 20cm smaller or 10cm bigger than the rug
        // on both width and length) first, then in stock, then the closest to rug
        // minus 5cm on each dimension, the first in size order on a tie. Rug
        // size unknown: the smallest in-stock size. Same rule as the Liquid.
        presetOption(group) {
          const r = this.rugDims();
          if (!r) return group.options.find((o) => this.isAvailable(o)) || group.options[0] || null;
          let best = null;
          let bestRank = Infinity;
          group.options.forEach((o) => {
            const d = this.parseDims(o.variant.dims);
            if (!d) return;
            let rank = Math.abs(d[0] - (r[0] - 5)) + Math.abs(d[1] - (r[1] - 5));
            if (!this.fitsSize(d, r)) {
              // Out of range: a smaller pad (hides under the rug) beats a bigger one.
              rank += 2e8;
              if (d[0] > r[0] + 10 || d[1] > r[1] + 10) rank += 2e8;
            }
            if (!this.isAvailable(o)) rank += 1e8;
            if (rank < bestRank) {
              bestRank = rank;
              best = o;
            }
          });
          return best || group.options[0] || null;
        }

        // Matched size: the preset when it's in range and in stock, else null.
        // A size matches the rug when it is at most 20cm smaller (10cm tucked
        // under each side) or at most 10cm larger (trimmed) on both dimensions.
        // Mirrors the Liquid preset rule.
        fitsSize(d, r) {
          return d[0] >= r[0] - 20 && d[0] <= r[0] + 10 && d[1] >= r[1] - 20 && d[1] <= r[1] + 10;
        }

        bestOption(group) {
          const r = this.rugDims();
          const o = r && this.presetOption(group);
          if (!o || !this.isAvailable(o)) return null;
          const d = this.parseDims(o.variant.dims);
          return this.fitsSize(d, r) ? o : null;
        }

        // Every row with at least one size shows (sold out or not).
        fitsRug(group) {
          return group.options.length > 0;
        }

        // The group's {pad, variant}: the size picked in its dropdown, else its preset.
        selection(key) {
          const group = this.group(key);
          if (!group) return null;
          const picked = this.choice[key];
          return group.options.find((o) => String(o.variant.id) === String(picked)) || this.presetOption(group);
        }

        // "Best fit": the first row, by rank, with a matched size.
        recommendedGroupKey() {
          const group = this.groups.find((g) => this.bestOption(g));
          return group ? group.key : null;
        }

        // Trimmable pad that reaches closer than 4cm to the rug's edge: the size
        // to trim it to (rug minus 5cm on those sides). Otherwise ''.
        trimTo(option) {
          const r = this.rugDims();
          const d = this.parseDims(option.variant.dims);
          if (!r || !d || !option.pad.trim || (d[0] <= r[0] - 4 && d[1] <= r[1] - 4)) return '';
          return [0, 1].map((i) => (d[i] > r[i] - 4 ? r[i] - 5 : d[i])).join('x') + 'cm';
        }

        // A new rug size resets every row to its new matched size.
        onRugChange() {
          const rugId = this.currentRugId();
          if (rugId === this.lastRugId) return;
          this.lastRugId = rugId;
          Object.keys(this.choice).forEach((key) => (this.choice[key] = null));
          this.renderCards();
          if (this.dialog.open) this.dialog.close();
        }

        // Every pad shows: on desktop always, on mobile once "Show more" is open.
        moreOpen() {
          return this.expanded || !this.mobileQuery.matches;
        }

        syncMoreToggle(count) {
          const labels = this.cardsEl.dataset;
          this.moreToggle.hidden = count < 1;
          this.moreToggle.setAttribute('aria-expanded', String(this.expanded));
          this.moreToggle.textContent = this.expanded
            ? labels.less
            : count === 1
            ? labels.moreOne
            : labels.more.replace('__N__', count);
        }

        // Open / close the other pads. Opening (and closing when the top card
        // stays the same) animates in place; closing with a lower pad chosen
        // re-renders so that pad moves to the top.
        toggleMore() {
          const more = this.cardsEl.querySelector('[data-pad-extra]');
          const count = more.querySelectorAll('[data-group]').length;
          this.expanded = !this.expanded;
          const chosenKey = this.selected.values().next().value;
          const lead = this.cardsEl.querySelector(':scope > [data-group]');
          if (!this.expanded && chosenKey && lead && lead.dataset.group !== chosenKey) {
            this.renderCards();
            return;
          }
          more.classList.toggle('is-open', this.expanded);
          more.inert = !this.expanded;
          this.syncMoreToggle(count);
        }

        disconnectedCallback() {
          // The drawer was moved to <body>; take it along when this block goes.
          if (this.whyDialog && this.whyDialog.parentElement === document.body) this.whyDialog.remove();
        }

        openWhy() {
          // Like the Size Guide drawer: lives under <body> so it takes the
          // page's colour scheme, not the product section's.
          if (this.whyDialog.parentElement !== document.body) document.body.appendChild(this.whyDialog);
          this.prevWhyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.whyDialog.showModal();
          this.whyDialog.querySelector('.pad-why__body').scrollTop = 0;
          // Next frame, so the transform transition runs.
          requestAnimationFrame(() => this.whyDialog.classList.add('is-open'));
        }

        closeWhy() {
          if (!this.whyDialog.open) return;
          this.whyDialog.classList.remove('is-open');
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const duration = parseFloat(getComputedStyle(this.whyDialog).transitionDuration) * 1000 || 0;
          clearTimeout(this.whyTimer);
          this.whyTimer = setTimeout(() => {
            if (!this.whyDialog.classList.contains('is-open')) this.whyDialog.close();
          }, reduce ? 0 : duration);
        }

        // Card name: the pad's real product title (of the pad behind the chosen
        // size). Same as the Liquid.
        cardName(option, group) {
          return (option && option.pad.title) || group.name;
        }

        // One choice at a time. With "Rug only" shown it works like radios (a pad,
        // or Rug only = key null); without it, tapping the chosen pad again
        // removes it (rug only).
        choose(key) {
          // A pad whose chosen size is sold out can't be picked.
          if (key && !this.isAvailable(this.selection(key))) return;
          const wasSelected = key && this.selected.has(key);
          this.selected.clear();
          if (key && !(wasSelected && !this.onlyCard)) this.selected.add(key);
          this.renderCards();
        }

        // Rug quantity from the quantity selector (outside the form, linked by form="").
        quantity() {
          const input = this.form && this.form.elements.namedItem('quantity');
          const n = parseInt(input && input.value, 10);
          return n > 0 ? n : 1;
        }

        // Cart lines for the chosen pad (one per rug), [] for rug only.
        // Public: the Buy it now button (buy-buttons.liquid) adds these too.
        padItems(qty) {
          const key = this.selected.values().next().value;
          const current = key && this.selection(key);
          return this.isAvailable(current) ? [{ id: current.variant.id, quantity: qty || this.quantity() }] : [];
        }

        showError(message) {
          this.errorEl.textContent = message || this.errorEl.dataset.fallback;
          this.errorEl.hidden = false;
        }

        make(tag, className, text) {
          const node = document.createElement(tag);
          if (className) node.className = className;
          if (text != null) node.textContent = text;
          return node;
        }

        renderCards() {
          const shown = this.groups.filter((group) => this.fitsRug(group));
          // A chosen pad that's gone or whose size is sold out is dropped.
          this.selected.forEach((key) => {
            if (!shown.some((group) => group.key === key) || !this.isAvailable(this.selection(key))) {
              this.selected.delete(key);
            }
          });
          if (!shown.length) {
            this.style.display = 'none';
            return;
          }
          this.style.display = '';
          // Rows are rebuilt on every change; keep keyboard focus where it was.
          const active = document.activeElement;
          const focusedRow = active && this.cardsEl.contains(active) ? active.closest('[data-group]') : null;
          const focusedKey = focusedRow && focusedRow.dataset.group;
          const focusedPart = !focusedRow
            ? null
            : active.matches('[data-pad-change]')
            ? '[data-pad-change]'
            : active.matches('[data-pad-size]')
            ? '[data-pad-size]'
            : null;

          const labels = this.cardsEl.dataset;
          const bestKey = this.recommendedGroupKey();
          // Recommended on top (else the first by rank); the rest follow by
          // rank. Closed with another pad chosen: that pad goes on top instead.
          const chosenKey = this.selected.values().next().value;
          let leadKey = bestKey || shown[0].key;
          if (!this.moreOpen() && chosenKey) leadKey = chosenKey;
          const ordered = shown.filter((g) => g.key === leadKey).concat(shown.filter((g) => g.key !== leadKey));

          this.cardsEl.innerHTML = '';
          const more = this.make('div', 'setup-selector__more' + (this.moreOpen() ? ' is-open' : ''));
          more.id = 'PadMore-' + (this.dataset.sectionId || '');
          more.dataset.padExtra = '';
          more.inert = !this.moreOpen();
          const moreInner = this.make('div', 'setup-selector__more-inner');
          more.appendChild(moreInner);
          ordered.forEach((group, index) => {
            const current = this.selection(group.key);
            const isActive = this.selected.has(group.key);
            const isBest = group.key === bestKey;
            const soldOut = !this.isAvailable(current);
            const price = soldOut ? labels.outLabel : this.money(current.variant.price);
            const row = this.make(
              'div',
              'setup-selector__card' +
                (isBest ? ' setup-selector__card--best' : '') +
                (soldOut ? ' setup-selector__card--soldout' : '') +
                (isActive ? ' setup-selector__card--active' : '')
            );
            row.dataset.group = group.key;
            row.setAttribute('role', this.onlyCard ? 'radio' : 'checkbox');
            row.setAttribute('tabindex', '0');
            row.setAttribute('aria-checked', String(isActive));
            if (soldOut) row.setAttribute('aria-disabled', 'true');
            const name = this.cardName(current, group);
            row.setAttribute('aria-label', name + ', ' + price + (isBest ? ', ' + labels.bestLabel : ''));
            if (isBest) row.appendChild(this.make('span', 'setup-selector__badge', labels.bestLabel));

            // Tick box, photo, name over the size dropdown, price over "Why this?".
            row.appendChild(this.make('span', 'setup-selector__check')).setAttribute('aria-hidden', 'true');
            const thumb = this.make('span', 'setup-selector__thumb');
            if (current.pad.image) {
              const img = document.createElement('img');
              img.src = current.pad.image;
              img.alt = '';
              img.width = 54;
              img.height = 54;
              img.loading = 'lazy';
              thumb.appendChild(img);
            }
            row.appendChild(thumb);

            const info = this.make('span', 'setup-selector__info');
            info.appendChild(this.make('span', 'setup-selector__name', name));
            const wrap = this.make('span', 'setup-selector__select');
            const selectId = 'PadSize-' + (this.dataset.sectionId || '') + '-' + (index + 1);
            const label = this.make('label', 'visually-hidden', labels.sizeLabel + ': ' + name);
            label.htmlFor = selectId;
            const select = document.createElement('select');
            select.id = selectId;
            select.dataset.padSize = '';
            group.options.forEach((o) => {
              const option = document.createElement('option');
              option.value = o.variant.id;
              option.textContent = o.variant.dims + (this.isAvailable(o) ? '' : ' \u2013 ' + labels.outLabel);
              option.selected = o === current;
              select.appendChild(option);
            });
            wrap.append(label, select);
            info.appendChild(wrap);
            row.appendChild(info);

            const aside = this.make('span', 'setup-selector__aside');
            aside.appendChild(this.make('span', 'setup-selector__price' + (soldOut ? ' setup-selector__price--out' : ''), price));
            const change = this.make('button', 'setup-selector__change', labels.changeLabel);
            change.type = 'button';
            change.dataset.padChange = '';
            change.setAttribute('aria-haspopup', 'dialog');
            change.setAttribute('aria-label', labels.changeLabel + ' ' + name);
            aside.appendChild(change);
            row.appendChild(aside);
            (index === 0 ? this.cardsEl : moreInner).appendChild(row);
          });

          this.cardsEl.appendChild(more);
          this.syncMoreToggle(ordered.length - 1);

          if (this.onlyCard) {
            const noneActive = this.selected.size === 0;
            this.onlyCard.classList.toggle('setup-selector__card--active', noneActive);
            this.onlyCard.setAttribute('aria-checked', String(noneActive));
          }

          if (focusedKey) {
            const again = this.cardsEl.querySelector('[data-group="' + focusedKey + '"]');
            const target = again && (focusedPart ? again.querySelector(focusedPart) : again);
            if (target) target.focus();
          }
          this.errorEl.hidden = true;
        }

        // Details dialog: photos, description, trim note for the size chosen in
        // the row's dropdown, and "Use this underlay".
        openDialog(key) {
          const current = this.selection(key);
          if (!current) return;
          this.editing = key;

          const sub = this.querySelector('[data-pad-dialog-sub]');
          const rug = this.currentRug();
          sub.textContent = rug ? sub.dataset.template.replace('__SIZE__', rug.dims) : '';
          this.querySelector('[data-pad-dialog-title]').textContent = this.cardName(current, this.group(key));

          this.renderGallery(current.pad);
          this.renderAbout(current.pad);
          const hint = this.querySelector('[data-pad-size-hint]');
          const trim = this.trimTo(current);
          hint.textContent = trim ? hint.dataset.trim.replace('__SIZE__', trim) : '';
          const soldOut = !this.isAvailable(current);
          const pick = this.querySelector('[data-pad-dialog-pick]');
          pick.querySelector('[data-pad-dialog-size]').textContent = current.variant.dims;
          pick.querySelector('[data-pad-dialog-price]').textContent = soldOut
            ? this.cardsEl.dataset.outLabel
            : this.money(current.variant.price);
          pick.classList.toggle('pad-sheet__pick--out', soldOut);
          this.querySelector('[data-pad-confirm]').disabled = soldOut;
          // "View product": the pad's own page, on the size chosen in the row.
          const view = this.querySelector('[data-pad-view]');
          view.hidden = !current.pad.url;
          view.href = current.pad.url ? current.pad.url + '?variant=' + current.variant.id : '#';

          this.prevBodyOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.dialog.showModal();
          this.querySelector('.pad-sheet__body').scrollTop = 0;
          this.galleryEl.scrollLeft = 0;
          this.updateGallery();
          this.syncMore();
          const confirm = this.querySelector('[data-pad-confirm]');
          (confirm.disabled ? this.querySelector('[data-pad-dialog-close]') : confirm).focus();
        }

        // ----- Picker carousel -----
        renderGallery(pad) {
          if (this.galleryPadId === pad.id && this.galleryEl.children.length) return;
          this.galleryPadId = pad.id;
          const images = pad.images && pad.images.length ? pad.images : pad.image ? [pad.image] : [];
          this.galleryWrap.hidden = !images.length;
          this.galleryWrap.classList.toggle('pad-sheet__gallery--single', images.length < 2);
          this.galleryEl.innerHTML = '';
          images.forEach((src, i) => {
            const slide = document.createElement('div');
            slide.className = 'pad-sheet__slide';
            const img = document.createElement('img');
            img.src = src;
            img.alt = i === 0 ? pad.title : '';
            img.width = 1000;
            img.height = 750;
            img.loading = i < 2 ? 'eager' : 'lazy';
            slide.appendChild(img);
            this.galleryEl.appendChild(slide);
          });
          this.galleryEl.scrollLeft = 0;
          this.updateGallery();
        }

        // "About this underlay": the pad's product description (HTML), clamped
        // with "See more". No description: its one-line "best for" instead, so
        // the dialog never opens empty.
        renderAbout(pad) {
          if (this.aboutPadId === pad.id) return;
          this.aboutPadId = pad.id;
          const html = String(pad.description || '').trim();
          if (html) {
            // Merchant-authored product description (theme-rendered HTML).
            this.descEl.innerHTML = html;
          } else {
            this.descEl.replaceChildren(this.make('p', null, pad.bestFor || ''));
          }
          this.aboutEl.hidden = !html && !pad.bestFor;
          this.descEl.classList.remove('is-open');
          this.moreBtn.setAttribute('aria-expanded', 'false');
          this.moreBtn.textContent = this.moreBtn.dataset.more;
          requestAnimationFrame(() => this.syncMore());
        }

        // Show "See more" (and the fade) only when the description overflows.
        syncMore() {
          if (this.descEl.classList.contains('is-open')) return;
          const overflows = this.descEl.scrollHeight > this.descEl.clientHeight + 1;
          this.moreBtn.hidden = !overflows;
          this.descEl.classList.toggle('is-clamped', overflows);
        }

        galleryOffset(slide) {
          const pad = parseFloat(getComputedStyle(this.galleryEl).paddingLeft) || 0;
          return slide.offsetLeft - this.galleryEl.offsetLeft - pad;
        }

        galleryIndex() {
          const slides = Array.from(this.galleryEl.children);
          const left = this.galleryEl.scrollLeft;
          let active = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(this.galleryOffset(slide) - left) < Math.abs(this.galleryOffset(slides[active]) - left)) active = i;
          });
          if (left + this.galleryEl.clientWidth >= this.galleryEl.scrollWidth - 2) active = slides.length - 1;
          return active;
        }

        stepGallery(dir) {
          const slides = this.galleryEl.children;
          const target = slides[Math.max(0, Math.min(slides.length - 1, this.galleryIndex() + dir))];
          if (!target) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.galleryEl.scrollTo({ left: this.galleryOffset(target), behavior: reduce ? 'auto' : 'smooth' });
        }

        updateGallery() {
          const total = this.galleryEl.children.length;
          if (total < 2) {
            this.galleryCount.textContent = '';
            return;
          }
          const i = this.galleryIndex();
          this.galleryCount.textContent = i + 1 + ' / ' + total;
          this.galleryPrev.disabled = i === 0;
          this.galleryNext.disabled = i === total - 1;
        }

        // Store currency, no trailing zeros (like money_without_trailing_zeros).
        money(cents) {
          const amount = cents / 100;
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
              style: 'currency',
              currency: this.dataset.currency || 'AUD',
              currencyDisplay: 'narrowSymbol',
              // Two decimals, like the store's money format ("$79.00").
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(amount);
          } catch (e) {
            return '$' + amount.toFixed(2);
          }
        }

        // Add to cart: the rug (at the chosen quantity) plus the chosen pad, one
        // per rug, in one request.
        onSubmit(evt) {
          if (!this.selected.size) return;
          const idInput = this.form.querySelector('.product-variant-id');
          if (!idInput || idInput.disabled) return;
          const qty = this.quantity();
          const padItems = this.padItems(qty);
          if (!padItems.length) return;

          evt.preventDefault();
          evt.stopImmediatePropagation();

          const btn = evt.currentTarget;
          const spinner = btn.querySelector('.loading__spinner');
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('loading');
          if (spinner) spinner.classList.remove('hidden');

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

          // Carry the pre-order selling plan. This handler bypasses the form's normal
          // submit, so without it the rug is added at full price with no plan — the
          // customer picks Partial payment, then the cart shows neither badge nor
          // deposit. The pad is in stock and paid in full, so it gets no plan.
          // :not(:disabled): preorder-gate.liquid disables the input on in-stock variants
          // and in built-in (full payment only) mode, and a disabled input must not submit.
          const spEl =
            this.form.querySelector('[name="selling_plan"]:checked:not(:disabled)') ||
            this.form.querySelector('[name="selling_plan"]:not(:disabled)');
          const rugLine = { id: Number(idInput.value), quantity: qty };
          if (spEl && spEl.value) rugLine.selling_plan = Number(spEl.value);

          // Pre-order note on the rug line only (the pad ships now). Same rule as
          // buy-buttons.liquid: follow the submit button's data-preorder.
          const propEl = this.form.querySelector('[data-preorder-property]');
          const submitEl = this.form.querySelector('.product-form__submit');
          if (propEl && submitEl && submitEl.hasAttribute('data-preorder')) {
            rugLine.properties = { [propEl.name.slice('properties['.length, -1)]: propEl.value };
          }

          const body = { items: [rugLine].concat(padItems) };
          this.errorEl.hidden = true;
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.sections = cart.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
          }

          fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify(body),
          })
            .then((r) => r.json())
            .then((response) => {
              if (response.status) {
                this.showError(response.description || response.message);
                return;
              }
              if (cart && cart.classList && cart.classList.contains('is-empty')) {
                cart.classList.remove('is-empty');
              }
              if (cart && typeof cart.renderContents === 'function') {
                cart.renderContents(response);
              } else {
                window.location = (window.routes && window.routes.cart_url) || '/cart';
              }
            })
            .catch(() => this.showError())
            .finally(() => {
              btn.removeAttribute('aria-disabled');
              btn.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('wishlist-toggle')) return;

    class WishlistToggle extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.appSelector = this.dataset.appSelector || '.Vtl-WishlistIcon__ProductPageWrapper';
        this.btn = this.querySelector('[data-wishlist-add]');
        this.addLabel = this.querySelector('[data-wishlist-label]');
        this.addedLabel = this.querySelector('[data-wishlist-added-label]');
        this._baseFill = null;

        var self = this;
        this.btn.addEventListener('click', function () { self.trigger(); });
        this.wireApp();
      }

      appWrap() {
        return document.querySelector(this.appSelector);
      }

      appButton() {
        var w = this.appWrap();
        if (!w) return null;
        return w.querySelector('.Vtl-WishlistButton__WishlistIconButton, button, [role="button"]') || w;
      }

      trigger() {
        var b = this.appButton();
        if (!b) return;
        b.click();
        var self = this;
        // The app updates its own heart asynchronously; reflect it a moment later.
        setTimeout(function () { self.sync(); }, 120);
        setTimeout(function () { self.sync(); }, 550);
      }

      isSaved() {
        var w = this.appWrap();
        if (!w) return false;
        // 1) active/added/selected/filled class anywhere in the app widget.
        if (w.querySelector('[class*="active"],[class*="Active"],[class*="added"],[class*="Added"],[class*="selected"],[class*="Selected"],[class*="filled"],[class*="Filled"]')) {
          return true;
        }
        // 2) title text flips to a "remove/saved" phrasing.
        var titled = w.querySelector('[title]');
        if (titled && /remove|saved|added|wishlisted/i.test(titled.getAttribute('title') || '')) {
          return true;
        }
        // 3) heart fill changed from its empty baseline.
        var svg = w.querySelector('svg');
        if (svg) {
          var fill = (svg.style && svg.style.fill) || svg.getAttribute('fill') || '';
          if (fill && this._baseFill != null && fill !== this._baseFill && !/none/i.test(fill)) {
            return true;
          }
        }
        return false;
      }

      sync() {
        var saved = this.isSaved();
        this.classList.toggle('is-saved', saved);
        if (this.addLabel) this.addLabel.hidden = saved;
        if (this.addedLabel) this.addedLabel.hidden = !saved;
        if (this.btn) this.btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      }

      wireApp() {
        var self = this;
        var wire = function () {
          var w = self.appWrap();
          if (!w) return false;
          var svg = w.querySelector('svg');
          if (svg && self._baseFill == null) {
            self._baseFill = (svg.style && svg.style.fill) || svg.getAttribute('fill') || '';
          }
          self.sync();
          if (self._mo) self._mo.disconnect();
          self._mo = new MutationObserver(function () { self.sync(); });
          self._mo.observe(w, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class', 'title', 'style', 'fill']
          });
          return true;
        };

        if (!wire()) {
          // The app injects its button after load — wait for it to appear.
          var docMo = new MutationObserver(function () {
            if (wire()) docMo.disconnect();
          });
          docMo.observe(document.documentElement, { childList: true, subtree: true });
          setTimeout(function () { docMo.disconnect(); }, 20000);
        }
      }
    }

    customElements.define('wishlist-toggle', WishlistToggle);
  })();
  } catch(e) { console.error(e); }
})();

})();
